module.exports = __webpack_public_path__ + "pc/img/main_swiper01.5c1c2d98.jpg";